import { addToCart } from '@ynap/cart-state'
import { Catalogue } from '@ynap/api-utils'
import { ADD_TO_CART_REQUEST } from '../constants/ActionTypes'
import { getLocale } from '@ynap/cart-state'
import { getWatsonConfig } from '@ynap/cart-state/src/selectors/getConfig'
import { fetchCartSuccess } from './checkout'
import { checkRectificationOnSuccess } from './cartRectification'

type Params = {
    setActionNotificationOnError: boolean,
    addToCartLoading: boolean,
    reservationId: string,
    includeShoppingBag: boolean,
}

type Options = {
    handleSuccess?: () => NodeJS.Timeout;
  };

export const addToBagByProductColour = (partNumber: string, setActionNotificationOnError: boolean = true, addToCartLoading: boolean, reservationId: string) => {
    return async (dispatch, getState, fetch) => {
        dispatch({ type: ADD_TO_CART_REQUEST })
        const state = getState()
        const locale = getLocale(state)
        const watsonConfig = getWatsonConfig(state)
        const availabilityRequest = Catalogue.getProductAvailability({ ...watsonConfig, ...locale, partNumber })

        return fetch(availabilityRequest)
            .then((response) => {
                return response.json()
            })
            .then((json) => {
                const [sku] = json.skus
                return addToCart(sku.gtin, {
                    setActionNotificationOnError,
                    addToCartLoading,
                    reservationId,
                    includeShoppingCart: true,
                })(dispatch, getState, fetch, (shoppingCartJson) => {
                    dispatch(fetchCartSuccess(shoppingCartJson.shoppingCart))
                    checkRectificationOnSuccess(dispatch, shoppingCartJson)
                })
            })
    }
}

export const addToBagWithCartSync = (partNumber: string, params: Params, options: Options) => {
    return async (dispatch, getState, fetch) => {
        return addToCart(partNumber, params)(dispatch, getState, fetch, (shoppingCartJson) => {
            dispatch(fetchCartSuccess(shoppingCartJson.shoppingCart))
            checkRectificationOnSuccess(dispatch, shoppingCartJson)
            options?.handleSuccess?.()
        })
    }
}
